import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 144rem;
  padding: 0;
  width: 100%;
`;
